import fetch from "auth/FetchInterceptor";

const loginImagesService = {};

loginImagesService.getRandomImage = function () {
	return fetch({
		url: "/v1/rest/random-login-image",
		method: "get",
		headers: { "public-request": true },
	});
};

loginImagesService.get = function () {
	return fetch({
		url: "/v1/rest/login-images",
		method: "get",
		headers: { "public-request": true },
	});
};

loginImagesService.getById = function (id) {
	return fetch({
		url: "/v1/rest/login-images/" + id,
		method: "get",
	});
};

loginImagesService.create = function (data) {
	return fetch({
		url: "/v1/rest/login-images",
		method: "post",
		data: data,
	});
};

loginImagesService.delete = function (id) {
	return fetch({
		url: "/v1/rest/login-images/" + id,
		method: "delete",
	});
};

export default loginImagesService;
